import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
// Import RemoteConfig
import { ConfigService } from './services/remoteConfig';
// Import styles
// eslint-disable-next-line import/no-extraneous-dependencies
import 'bootstrap/dist/css/bootstrap.min.css';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'bootstrap';
// Import your CSS
import './assets/main.css';

// Define async initialization function
const initApp = async () => {
  try {
    // Initialize config
    console.log('Initializing RemoteConfig...');
    await ConfigService.initialize();
    console.log('RemoteConfig initialized successfully');

    // Initialize the Vue app
    const app = createApp(App);

    // Add dependencies
    app.use(router);

    // Mount the app
    app.mount('#app');

    // Make config available globally for debugging
    window.appConfig = ConfigService.getAll();
    window.getConfig = key => ConfigService.get(key);

    // Add some helpful debug info to console
    if (process.env.NODE_ENV !== 'production') {
      console.log('==== DEV MODE: Debug Commands ====');
      console.log('To view all config: window.appConfig');
      console.log('To get specific value: window.getConfig("keyName")');
    }
  } catch (error) {
    console.error('Failed to initialize app:', error);
  }
};

// Start the app
initApp();

// Global error handler
window.addEventListener('error', event => {
  console.error('Global error caught:', event.error);
});

window.addEventListener('unhandledrejection', event => {
  console.error('Unhandled promise rejection:', event.reason);
});
